// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__fJApC","input":"LoginForm_input__lOI02","forgot-password":"LoginForm_forgot-password__q6OpF"};